// src/utils/formatTimeToMMSS.js
export const formatTime = (timeInSeconds) => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

// Función para formatear el tiempo a hh:mm:ss
export const formatTimeToHHMMSS = (timeInSeconds) => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

// Función para calcular el GAP basado en la categoría de carrera y la fórmula
export const calculateGap = (raceCategory, isITRA) => {
  // Aquí puedes reemplazar la lógica con un cálculo más realista
  if (isITRA) {
    return 5 * 60;  // Devolviendo 5 minutos como ejemplo
  }
  return 0;
};

// Función para calcular el GAP medio entre todas las vueltas
export const calculateGapMedio = (laps, formula) => {
  const gaps = [];
  laps.forEach((lap, index) => {
    let gap = 0;
    if (formula === 'ITRA') {
      // Cálculo del gap medio según la fórmula ITRA
      gap = (lap.total_elapsed_time / lap.total_distance) * 1000; // Fórmula ITRA
    } else if (formula === 'UTMB') {
      // Cálculo del gap medio según la fórmula UTMB
      gap = (lap.total_elapsed_time / lap.total_distance) * 800; // Fórmula UTMB
    } else if (formula === 'IAAF') {
      // Cálculo del gap medio según la fórmula IAAF
      gap = (lap.total_elapsed_time / lap.total_distance) * 1200; // Fórmula IAAF
    }
    gaps.push(gap);
  });
  
  // Puedes agregar un cálculo del GAP promedio si es necesario
  const totalGap = gaps.reduce((acc, gap) => acc + gap, 0);
  return totalGap / gaps.length;  // Promedio de GAP
};